var lastScrollTop = 0;
var lastScrollDir = 0;
var upgradeLoading = false;
var triggerCustomCartDataLoading = false;

try {
  console.log("admin-release!!!");
  if (
    localStorage.getItem("admin-release") == "admin-release" ||
    window.location.href.indexOf("myshopify") > -1 ||
    window.location.href.indexOf("oseid") > -1 ||
    window.location.href.indexOf("admin-release") > -1
  ) {
    localStorage.setItem("admin-release", "admin-release");
    document.getElementById("fs-release-overlay").remove();
    setTimeout(() => UnlockScroll(), 500);
  } else {
    // setTimeout(() => LockScroll(), 500);
  }
} catch {
  console.error("release disable fail");
}

//
document.addEventListener("rebuy:smartcart.init", (event) => {
  ConfigureCartCount();
});
document.addEventListener("rebuy:smartcart.show", (event) => {
  ConfigureCartCount();
});
document.addEventListener("rebuy:cart.change", (event) => {
  ConfigureCartCount();
});

setTimeout(() => {
  if (window.location.href.indexOf("admin=1") > -1) {
    $("body").addClass("admin-view");
    $("#header-countdown").show();
  }
}, 1000);

function ConfigureCartCount() {
  var itemCount = Rebuy.Cart.itemCount();
  var lineCount = Rebuy.Cart.lineCount();
  $("#cart-count-mb").text(itemCount);
  $("#cart-count-dt").text(itemCount);
  setTimeout(() => {
    $("#cart-count-mb").show();
    $("#cart-count-dt").show();
  }, 100);
}

function CustomReset() {
  document
    .querySelector(".cart-button-checkout-text")
    ?.classList.remove("hide");
  document
    .querySelector(".cart-button-checkout-spinner")
    ?.classList.add("hide");
}

function CustomListen() {
  document.querySelectorAll("button.secondary.qty-plus").forEach((item) => {
    item.addEventListener("click", function (e) {
      document
        .querySelectorAll(".quantity-controls button.qty-plus:not(.secondary)")
        .forEach((_i) => {
          _i.click();
        });
    });
  });

  document.querySelectorAll("button.secondary.qty-minus").forEach((item) => {
    item.addEventListener("click", function (e) {
      document
        .querySelectorAll(".quantity-controls button.qty-minus:not(.secondary)")
        .forEach((_i) => {
          _i.click();
        });
    });
  });
}

function CustomQuantityChanged(variant_id, e, main_price, var_price) {
  window.product.CompareAtPrice = `${getCurrencySymbol()}${var_price / 100}`;
  if (main_price == var_price)
    window.product.CompareAtPrice = `${getCurrencySymbol()}0.00`;
  var x = document.getElementsByClassName(e.target.className);
  for (var i = 0; i < x.length; i++) {
    x[i].checked = true;
  }
  window.product.Price = `${getCurrencySymbol()}${main_price / 100}`;
  //window.product.CompareAtPrice = "£0.00";
  custom_variant_change(variant_id);
}

function recalcPrice(newVal, variant_id) {
  if (typeof window.product === "undefined" || window.product == null) return;
  var bp = parseFloat(window.product.Price.replace(getCurrencySymbol(), ""));
  var newPrice = bp * newVal;
  var quant = document.getElementsByClassName("quantity-selector");
  for (var i = 0; i < quant.length; i++) {
    quant[i].value = newVal;
  }
  var ptu = document.getElementsByClassName("update_price_field");
  for (var i = 0; i < ptu.length; i++) {
    ptu[
      i
    ].innerHTML = `<span class="money" data-variant-id="${variant_id}">${getCurrencySymbol()}${newPrice.toFixed(
      2
    )}</span>`;
  }

  var cptu = document.querySelectorAll(".compare-at-price.js");
  for (var i = 0; i < cptu.length; i++) {
    cptu[i].innerHTML = `<span class="money" data-variant-id="${variant_id}"></span>`;
  }

  if (window.product.CompareAtPrice == "£0.00") {
    var cptu = document.querySelectorAll(".compare-at-price.js");
    for (var i = 0; i < cptu.length; i++) {
      cptu[i].innerHTML = `<span class="money"></span>`;
    }
  } else {
    var compAtPrice = parseFloat(
      window.product.CompareAtPrice.replace(getCurrencySymbol(), "")
    );
    var newCompPrice = compAtPrice * newVal;
    var cptu = document.querySelectorAll(".compare-at-price.js");
    for (var i = 0; i < cptu.length; i++) {
      cptu[
        i
      ].innerHTML = `<span class="money" data-variant-id="${variant_id}">${getCurrencySymbol()}${newCompPrice.toFixed(
        2
      )}</span>`;
    }
  }
}

function DisplayPrice(unitBasePrice, unitCompareAtPrice, quantity = 1, product_id, unitAddOnPrice = 0) {
  // unitBasePrice: The base price of the product per unit.
  // unitCompareAtPrice: The compare-at price of the product per unit (optional).
  // unitAddOnPrice: Additional price per unit for add-ons. Defaults to 0.
  // quantity: The number of units. Defaults to 1.
  // product_id: The ID of the product.
  console.log("DisplayPrice", unitBasePrice, unitCompareAtPrice, quantity, product_id, unitAddOnPrice);
  // Calculate the total final price for the given quantity.
  const totalEffectivePrice = (unitBasePrice * quantity) + unitAddOnPrice;
  const totalUnitCompareAtPrice = unitCompareAtPrice + unitAddOnPrice;

  const ptuElements = document.getElementsByClassName("update_price_field");
  for (let i = 0; i < ptuElements.length; i++) {
    let dataPriceMultiplierAttribute = '';
    // Calculate igMultiplier and its attribute only if unitCompareAtPrice is valid.
    // igMultiplier is the ratio of the current effective unit price to the unit compare-at price.
    if (totalUnitCompareAtPrice != undefined && totalUnitCompareAtPrice > 0) {
      var igMultiplier = unitBasePrice / totalUnitCompareAtPrice;
      if (!isNaN(igMultiplier) && isFinite(igMultiplier)) {
        console.log("igMultiplier", igMultiplier, "quantity", quantity);
        // The data-price-multiplier for the main price field was igMultiplier * quantity.
        // Check if selected option is a subscription, if it's, set the data-price-multiplier to 1, because subscription price is using a different product than the base one.
      // So, on OTP cases, the multiplier needs to be applied
      var selling_plan = ptuElements[i].closest('form').querySelector('#selling_plan').value;
      if( selling_plan == '') {
        igMultiplier = igMultiplier * quantity;
      }
        dataPriceMultiplierAttribute = `data-price-multiplier="${(igMultiplier * quantity).toFixed(4)}" data-quantity="${quantity}"`;
      }
    }
    
    // Display the total effective price.
    ptuElements[i].innerHTML = `<span class="money igPrice" data-variant-id="${product_id}" ${dataPriceMultiplierAttribute}>${getCurrencySymbol()}${totalEffectivePrice.toFixed(2)}</span>`;
  }

  const cptuElements = document.querySelectorAll(".compare-at-price.js");

  // Determine if the compare-at price should be shown.
  // It's shown if totalUnitCompareAtPrice is valid, positive, and strictly greater than the unitBasePrice (before add-ons).
  // This ensures that if the base product is on sale, its original price is shown,
  // even if add-ons might increase the final effective price above totalUnitCompareAtPrice.
  const showCompareAtPrice = totalUnitCompareAtPrice != undefined &&
                             totalUnitCompareAtPrice > 0 &&
                             parseFloat(totalUnitCompareAtPrice.toFixed(2)) > parseFloat(unitBasePrice.toFixed(2));

  for (let i = 0; i < cptuElements.length; i++) {
    if (showCompareAtPrice) {
      // Display the totalUnitCompareAtPrice (per unit).
      // The data-price-multiplier for the compare-at price field remains 'quantity'.
      // Check if selected option is a subscription, if it's, set the data-price-multiplier to 1, because subscription price is using a different product than the base one.
      // So, on OTP cases, the multiplier needs to be applied
      var selling_plan = cptuElements[i].closest('form').querySelector('#selling_plan').value;
      cptuElements[i].innerHTML = `<span class="money igPrice" data-variant-id="${product_id}" data-price-multiplier="${selling_plan == '' ? quantity : 1}">${getCurrencySymbol()}${(totalUnitCompareAtPrice).toFixed(2)}</span>`;
    } else {
      // Hide compare-at price by rendering an empty span or a span without price.
      cptuElements[i].innerHTML = `<span class="money" data-product-id="${product_id}"></span>`;
    }
  }
}

function getCurrencySymbol() {
  const locale = window.Shopify.locale;
  const currency = window.Shopify.currency.active;
  return (0)
    .toLocaleString(locale, {
      style: "currency",
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    .replace(/\d/g, "")
    .trim();
}

function custom_variant_change(variant_id) {
  /* ADD SOLD OUT SUPPORT? */
  var qtyInput = document.getElementById("quantity");
  var val = parseInt(qtyInput.value.toString(), 10);

  var variantInput = document.getElementById("product_id");
  variantInput.value = variant_id;

  recalcPrice(val, variant_id);
}

CustomListen();
CustomReset();
ConfigureWhitebox();
// ConfigureRecharge();
ConfigureSubAndSave();
window.onload = function () {
  ConfigureWhitebox();
};

function ConfigureSubAndSave() {
  console.log("ConfigureSubAndSave");
  $(".selected_selling_plan:not(.__soldout__, .__oneplan__)").on("click", (e) => {
    var product_form_id = $(e.currentTarget).attr("data-form");
    // close others
    $(`.product-form:not(#${product_form_id}) .selling_plan_options`).addClass(
      "closed"
    );
    $(
      `.product-form:not(#${product_form_id}) .selected_selling_plan`
    ).removeClass("open");

    //
    if ($(e.currentTarget).hasClass("open")) {
      $(e.currentTarget).removeClass("open");
      $(`#${product_form_id} .selling_plan_options`).addClass("closed");
    } else {
      $(e.currentTarget).addClass("open");
      $(`#${product_form_id} .selling_plan_options`).removeClass("closed");
    }
  });
}

function SellingPlanRender() {
  $(".selected_selling_plan").each((i, e) => {
    var productFormId = $(e).attr("data-form-id");
    var productCard = $(e).attr("data-for");
    var productId = $(e).attr("data-product");
    var variantId = $(e).attr("data-variant");

    // update selected html
    var updatingIndex = window._product_options[`${productFormId}`][
      `${productCard}`
    ].findIndex((e, i) => e.product == productId && e.variant == variantId);
    if (updatingIndex >= 0) {
      var product =
        window._product_options[`${productFormId}`][`${productCard}`][
          updatingIndex
        ];
      console.log(product);
      $(`#${productFormId}.product-form .selected_selling_plan`).html("");
      $(`#${productFormId}.product-form .selected_selling_plan`).append(
        product.html
      );

      $(`#${productFormId}.product-form .selling_plan_options`).html("");
      window._product_options[`${productFormId}`][`${productCard}`].forEach(
        (e, i) => {
          if (i == updatingIndex) return;
          $(`#${productFormId}.product-form .selling_plan_options`).append(
            window._product_options[`${productFormId}`][`${productCard}`][i]
              .html
          );
        }
      );

      // update form
      $(`#${productFormId}.product-form input#selling_plan`).val(
        product.sellingPlanId
      );
      $(`#${productFormId}.product-form input#id`).val(product.variant);
      $(`#${productFormId}.product-form input#product-id`).val(product.product);
    }
  });
}

function SellingPlanChange(event) {
  var $parent = $(event).parent(".selected_selling_plan");
  if ($parent.attr("data-sub-count") == 1) return; // dont open with only the main item as an option
  if ($parent.length > 0) return; // already selected
  var productFormId = $(event).attr("data-form-id");
  var productCard = $(event).attr("data-for");
  var productId = $(event).attr("data-product");
  var variantId = $(event).attr("data-variant");

  // update selected html
  var updatingIndex = window._product_options[`${productFormId}`][
    `${productCard}`
  ].findIndex((e, i) => e.product == productId && e.variant == variantId);
  if (updatingIndex >= 0) {
    var product =
      window._product_options[`${productFormId}`][`${productCard}`][
        updatingIndex
      ];
    console.log(product);
    $(`#${productFormId}.product-form .selected_selling_plan`).html("");
    $(`#${productFormId}.product-form .selected_selling_plan`).append(
      product.html
    );

    $(`#${productFormId}.product-form .selling_plan_options`).html("");
    window._product_options[`${productFormId}`][`${productCard}`].forEach(
      (e, i) => {
        if (i == updatingIndex) return;
        $(`#${productFormId}.product-form .selling_plan_options`).append(
          window._product_options[`${productFormId}`][`${productCard}`][i].html
        );
      }
    );

    // update form
    $(`#${productFormId}.product-form input#selling_plan`).val(
      product.sellingPlanId
    );
    $(`#${productFormId}.product-form input#id`).val(product.variant);
    $(`#${productFormId}.product-form input#product-id`).val(product.product);
  }

  // close toggle
  $(`#${productFormId}.product-form .selling_plan_options`).addClass("closed");
  $(`#${productFormId}.product-form .selected_selling_plan`).removeClass(
    "open"
  );
}

function ConfigureRecharge() {
  console.log("WINDOW LOAD");
  if (window.location.href.indexOf("recurring/portal") > 0) {
    console.log("ON PAGE");
    setTimeout(() => {
      console.log("DO THING");
      $("._15b7gxl0.recharge-component-schedule-item").prepend(
        "<div class='bootstrap'><p class='d-block mb-2 fs-6'>Changes to your order may take a moment to reflect correct pricing. Please refresh after making any updates.</p></div>"
      );
      $("._15b7gxl0.recharge-component-schedule-item").prepend(
        "<div class='bootstrap'><p class='d-block mb-2 fs-6'>Note: Membership pricing is specific to individual active subscriptions. Making changes to your current subscription such as removing or swapping products may result in loss of loyalty perks and membership discounts.</p></div>"
      );

      const HAS_DISCOUNT = window.ReCharge.charges[0].discount_codes.length > 0;
      if (!HAS_DISCOUNT) return;
      const DISCOUNTCODE = window.ReCharge.charges[0].discount_codes[0].code;
      console.log("render discount", DISCOUNTCODE);
      $('div._15b7gxl0[data-testid="order-summary-wrapper"]').append(
        `<div class='bootstrap'><div class='d-flex align-items-center'><div class=''><span class='fs-6'>Discount</span></div><div class='d-flex'><div class='ms-1 d-flex gap-1 align-items-center'><div class='d-flex'><span class='_15b7gxl0 _17o99wpuf _17o99wpvc _17o99wpw6 _17o99wptf _17o99wphu _17o99wp3 _17o99wpli recharge-pill _16omeme0 v5g8zj0 v5g8zj2'><span role='heading' aria-level='4' class='_15b7gxl0 recharge-heading recharge-heading-h4 _1brvylo0 _1brvylo7 _1brvylo8 fw-bold fw-bold'>${DISCOUNTCODE}</span></span></div><div class='_15b7gxl0'><span role='button' tabindex='0' class='_15b7gxl0 _16omeme0 _1qyrsef0 _1qyrsef2 _1qyrsef5 _1qyrsef7 _1qyrsef9 _1qyrsefa'><div class='_15b7gxl0 _17o99wpw9 _17o99wpti _17o99wpuf _17o99wpvc _17o99wpmr _17o99wphx _17o99wplo _17o99wp0 recharge-icon n89mvw0 n89mvw8'><svg viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' width='16' height='16'><g stroke='currentColor' stroke-width='1.2' stroke-linecap='round' stroke-linejoin='round'><path d='M1.143 4h13.714M2.857 4h10.286v10.286A1.143 1.143 0 0 1 12 15.429H4a1.143 1.143 0 0 1-1.143-1.143V4ZM5.143 4v-.571a2.857 2.857 0 0 1 5.714 0V4M6.286 7.43v4.573M9.714 7.43v4.573'></path></g></svg></div><div style='border: 0px; clip: rect(0px, 0px, 0px, 0px); clip-path: inset(50%); height: 1px; margin: -1px; overflow: hidden; padding: 0px; position: absolute; width: 1px; white-space: nowrap;'>Remove</div></span></div></div></div></div></div>`
      );
    }, 10000);
  }
}

///

function ShowLoading() {
  document.getElementById("loadingOverlay").style.display = "flex";
  LockScroll();
}

// Function to hide the loading overlay
function HideLoading() {
  document.getElementById("loadingOverlay").style.display = "none";
  UnlockScroll();
}

/// WHITEBOX

function ConfigureWhitebox() {
  console.log("configure whitebox...");
  $("#custom_whitebox").on("click", (e) => {
    e.stopPropagation();
    //CloseWhitebox();
  });

  $("#whitebox_close").on("click", (e) => {
    e.stopPropagation();
    CloseWhitebox();
  });
}

function CloseWhitebox() {
  $("#custom_whitebox").hide();
  $("#whitebox_image").attr("src", "");
  $("#whitebox_sub_html").html("");
  UnlockScroll();
}

function OpenWhiteboxImage(imageSource, htmlId) {
  $("#whitebox_image").attr("src", imageSource);
  $("#whitebox_sub_html").html("");
  var toAdd = $(`#${htmlId}`).html();
  $("#whitebox_sub_html").html(toAdd);
  $("#wb_switch").hide();
  $("#custom_whitebox").show();
  LockScroll();
}

function OpenMultiWhiteboxImage(imageSources, names) {
  window.whiteboxImages = imageSources;
  $("#whitebox_image").attr("src", window.whiteboxImages[0]);
  $("#wb_switch").show();
  $("#wb_switch_1").text(names[0]);
  $("#wb_switch_2").text(names[1]);
  $("#custom_whitebox").show();
  LockScroll();
}

function LockedScroll() {
    return $("html").hasClass("whitebox-open");
}

function LockScroll() {
  var y = -scrollY;
  $("html").addClass("whitebox-open");
  $(".whitebox-open body").css("top", y);
}

function UnlockScroll() {
  var y = Number.parseFloat($(".whitebox-open body").css("top"));
  y = y * -1;
  $(".whitebox-open body").css("top", null);
  $("html").removeClass("whitebox-open");
  window.scrollTo({ top: y, left: 0, behavior: "instant" });
  setTimeout(() => {
    window.scrollTo({ top: y, left: 0, behavior: "instant" });
  }, 10);
}

function WhitboxSwitch(event) {
  const checked = $(event.target).is(":checked");
  if (checked) {
    $("#whitebox_image").attr("src", window.whiteboxImages[0]);
  } else {
    $("#whitebox_image").attr("src", window.whiteboxImages[1]);
  }
}

///

function SnippetProductUpdate(
  productFormId,
  productId,
  variantId,
  sellingPlanId,
  sellingPlanText
) {
  var quantity = 1;
  $(`#${productFormId} input#product_id`).val(variantId); // variantId
  $(`#${productFormId}  input#quantity`).val(
    sellingPlanId == undefined ? quantity : 1
  ); // quantity
  $(`#${productFormId}  input[name="product-id"]`).val(productId); // productId
  $(`#${productFormId}  input[name="selling_plan"]`).val(sellingPlanId); // sellingPlanId
  $(`#${productFormId}  input#option-0`).val(sellingPlanText); //option-0: 60 Capsules
  $(`#${productFormId}  input#purchase_type`).val(
    sellingPlanId == undefined ? "one-time" : "subscription"
  ); //purchase_type: subscription / one-time

  /*
        DisplayPrice(
            SELECTED_PRODUCT['price'] / 100,
            (quantity == 1 || quantity == undefined) ? SELECTED_PRODUCT['originalPrice'] / 100 : undefined,
            SELECTED_PRODUCT['sellingPlan'] == undefined ? quantity : 1
          );
        */
}


(function() {
  if (window.location.href.indexOf('/tools/') === -1) {
    return;
  }

  document.addEventListener("click", function(event) {
    var logoutButton = event.target.closest('.recharge-navigation-logout');

    if (logoutButton) {
      event.preventDefault(); 
      fetch('/account/logout')
        .then(function() { window.location.href = "/"; })
        .catch(function() { window.location.href = "/"; });
    }
  });
})();